import React                from 'react';
import ReactDOM             from 'react-dom/client';
import 'Public/Css/index.css';
import 'Public/Css/global.css';
import { App }              from 'View/Application/App/App';
import reportWebVitals      from './reportWebVitals';
import { Provider }         from 'react-redux';
import { Store, Persistor } from 'Redux/Config';
import Bootstrap            from 'Redux/Bootstrap';
import { Router }           from 'View/Application/Router/Router';
import { PersistGate }      from 'redux-persist/integration/react';
import dayjs                from 'dayjs';
import utc                  from 'dayjs/plugin/utc';
import timezone             from 'dayjs/plugin/timezone';
import locale               from 'antd/locale/de_DE';
import { ConfigProvider }   from 'antd';
import 'dayjs/locale/de';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('de');


const Application = () => (
  <React.StrictMode>
    <ConfigProvider locale={locale}>
      <Provider store={Store}>
        <PersistGate persistor={Persistor} loading={null}>
          <App>
            <Router/>
          </App>
        </PersistGate>
      </Provider>
    </ConfigProvider>
  </React.StrictMode>
);
Bootstrap()
  .then(() => Application())
  .catch((error) => console.error(error));

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - ReactDOM.createRoot is not yet in the types
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Application/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
